export enum ProcedureTestQuestionType {
  SingleChoice = 'single-choice',

  MultipleChoice = 'multiple-choice',

  Ordering = 'ordering',
}